module.exports = __webpack_public_path__ + "img/16l002-03.4c83c4c6.png";